module.exports = __webpack_public_path__ + "static/media/woo-logo.9295dbab.png";